import React from "react";
import { motion } from "framer-motion";

const COLORS = ["#C86641", "#E4B87A", "#2A6F41", "#2B2726"];

const HIDDEN = { opacity: 0 };
const VISIBLE = { opacity: 1 };
const delayFor = (i) => ({ delay: 0.1 + i * 0.08 });

export default function AgeDonut({ data, labels, fmt, size = 132 }) {
  const values = [data.p_0_14, data.p_15_29, data.p_30_59, data.p_60plus];
  const total = values.reduce((a, b) => a + b, 0) || 100;
  const r = size / 2 - 10;
  const cx = size / 2;
  const circ = 2 * Math.PI * r;
  let offset = 0;

  return (
    <div className="flex items-center gap-5" data-testid="age-donut">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="shrink-0 -rotate-90">
        <circle cx={cx} cy={cx} r={r} fill="none" stroke="#E5DCD0" strokeWidth="16" />
        {values.map((v, i) => {
          const len = (v / total) * circ;
          const dash = `${len} ${circ - len}`;
          const el = (
            <motion.circle
              key={labels[i]}
              cx={cx}
              cy={cx}
              r={r}
              fill="none"
              stroke={COLORS[i]}
              strokeWidth="16"
              strokeDasharray={dash}
              strokeDashoffset={-offset}
              initial={HIDDEN}
              animate={VISIBLE}
              transition={delayFor(i)}
            />
          );
          offset += len;
          return el;
        })}
      </svg>
      <ul className="space-y-1.5 text-sm flex-1 min-w-0">
        {values.map((v, i) => (
          <li key={labels[i]} className="flex items-center justify-between gap-3" data-testid={`age-row-${i}`}>
            <span className="flex items-center gap-2 text-ink/80">
              <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: COLORS[i] }} />
              {labels[i]}
            </span>
            <span className="stat-number text-ink">{fmt(v)}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
